import React from 'react';
import Icon from '../../../components/AppIcon';
import { formatCurrency } from '../../../utils/currency';

const AccountSummaryCard = ({ accountSummary = [], currency = 'USD' }) => {
  const formatAmount = (amount) => {
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount || 0);
    } catch (error) {
      return formatCurrency(amount || 0);
    }
  };

  const getAccountIcon = (type) => {
    switch (type) {
      case 'Asset':
        return 'Wallet';
      case 'Liability':
        return 'CreditCard';
      case 'Equity':
        return 'TrendingUp';
      case 'Revenue':
        return 'DollarSign';
      case 'Expense':
        return 'Receipt';
      default:
        return 'FileText';
    }
  };

  const getAccountColor = (type) => {
    switch (type) {
      case 'Asset':
        return 'success';
      case 'Liability':
        return 'error';
      case 'Equity':
        return 'primary';
      case 'Revenue':
        return 'success';
      case 'Expense':
        return 'secondary';
      default:
        return 'accent';
    }
  };

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-4 md:p-6">
      <h2 className="font-heading font-semibold text-lg md:text-xl text-foreground mb-4">
        Account Summary
      </h2>

      {accountSummary.length > 0 ? (
        <div className="space-y-3">
          {accountSummary.map((account, index) => {
            const iconColor = getAccountColor(account.account_type);
            return (
              <div
                key={index}
                className="flex items-center gap-3 p-3 rounded-lg bg-muted/50"
              >
                <div className={`
                  w-10 h-10 rounded-md flex items-center justify-center flex-shrink-0
                  ${iconColor === 'primary' ? 'bg-primary/10' : ''}
                  ${iconColor === 'secondary' ? 'bg-secondary/10' : ''}
                  ${iconColor === 'accent' ? 'bg-accent/10' : ''}
                  ${iconColor === 'success' ? 'bg-success/10' : ''}
                  ${iconColor === 'error' ? 'bg-error/10' : ''}
                `}>
                  <Icon name={getAccountIcon(account.account_type)} size={18} color={`var(--color-${iconColor})`} />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-body font-medium text-sm text-foreground mb-1">
                    {account.account_type}
                  </h3>
                  <p className="caption text-muted-foreground">
                    {account.account_count} account{account.account_count !== 1 ? 's' : ''}
                  </p>
                </div>
                <div className="text-right flex-shrink-0">
                  <p className="font-body font-semibold text-sm text-foreground">
                    {formatAmount(account.total_balance)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-center py-8">
          <Icon name="FileText" size={32} className="text-muted-foreground mx-auto mb-2" />
          <p className="text-muted-foreground">No account data available</p>
        </div>
      )}
    </div>
  );
};

export default AccountSummaryCard;
